import { color, font, radius } from '../theme/tokens.js';

const VARIANTS = {
  primary: {
    background: color.primary,
    color: color.inkInverse,
    border: 'none',
  },
  secondary: {
    background: color.surface,
    color: color.ink,
    border: `1.5px solid ${color.border}`,
  },
  quiet: {
    background: 'transparent',
    color: color.inkMuted,
    border: `1.5px solid ${color.border}`,
  },
  dark: {
    background: color.ink,
    color: color.inkInverse,
    border: 'none',
  },
};

/**
 * The app's standard button.
 *
 * @param {object} props
 * @param {'primary'|'secondary'|'quiet'|'dark'} [props.variant]
 * @param {boolean} [props.disabled]
 * @param {boolean} [props.loading]   Shows a spinner and blocks clicks.
 * @param {boolean} [props.fullWidth]
 * @param {() => void} [props.onClick]
 * @param {object} [props.style]
 * @param {React.ReactNode} props.children
 */
export function Button({
  variant = 'primary',
  disabled = false,
  loading = false,
  fullWidth = true,
  onClick,
  style,
  children,
}) {
  const inactive = disabled || loading;
  const palette = VARIANTS[variant];

  return (
    <button
      type="button"
      onClick={inactive ? undefined : onClick}
      disabled={inactive}
      style={{
        width: fullWidth ? '100%' : undefined,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 9,
        padding: '14px 22px',
        borderRadius: radius.lg,
        fontSize: font.size.lg,
        fontWeight: font.weight.bold,
        cursor: inactive ? 'default' : 'pointer',
        transition: 'all 0.2s',
        ...palette,
        ...(disabled
          ? { background: color.surfaceSunken, color: color.inkFaint, border: 'none' }
          : null),
        ...style,
      }}
    >
      {loading && <span className="spinner" />}
      {children}
    </button>
  );
}
